import { Pagination, Table } from "antd";

import CoinIcon from "../../../../assets/icons/ic_coins.svg";
import CashIcon from "../../../../assets/icons/ic_cash.svg";
import FreeCashIcon from "../../../../assets/icons/ic_free-cash.svg";

import "./stylesPromoTable.css";
import { useState } from "react";

function PromoTable() {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const handlePaginationChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const data = [
    {
      date: "Oct 05, 2024 12:34 PM",
      promotionName: "Welcome Bonus",
      bonusType: "Store Discount",
      PurchasePrice: "$ 4,500.00",
      BonusReceived: "50,00 + 500,00",
      status: "Lost",
      bonusPaidOut: "$ 25,77",
      cashIcon: true,
      coinIcon: true,
    },
    {
      date: "Oct 15, 2024 12:34 PM",
      promotionName: "Fall Cashback",
      bonusType: "Store Discount",
      PurchasePrice: "$ 200.00",
      BonusReceived: "50,00 + 500,00",
      status: "-",
      bonusPaidOut: "$ 50,87",
      cashIcon: true,
      coinIcon: true,
    },
    {
      date: "Oct 05, 2024 12:34 PM",
      promotionName: "Summer Sizzle",
      bonusType: "Free Bet Cash",
      PurchasePrice: "-",
      BonusReceived: "$ 2000.00",
      status: "-",
      bonusPaidOut: "$ 40,70",
      cashIcon: false,
      coinIcon: false,
      freeCashIcon: true,
    },
    {
      date: "Oct 05, 2024 12:34 PM",
      promotionName: "Welcome Bonus",
      bonusType: "Store Discount",
      PurchasePrice: "$ 4,500.00",
      BonusReceived: "50,00 + 500,00",
      status: "Lost",
      bonusPaidOut: "$ 25,77",
      cashIcon: true,
      coinIcon: true,
    },
    {
      date: "Oct 05, 2024 12:34 PM",
      promotionName: "Summer Sizzle",
      bonusType: "Free Bet Cash",
      PurchasePrice: "-",
      BonusReceived: "$ 2000.00",
      status: "-",
      bonusPaidOut: "$ 40,70",
      cashIcon: false,
      coinIcon: false,
      freeCashIcon: true,
    },
    {
      date: "Oct 15, 2024 12:34 PM",
      promotionName: "Fall Cashback",
      bonusType: "Store Discount",
      PurchasePrice: "$ 200.00",
      BonusReceived: "50,00 + 500,00",
      status: "Lost",
      bonusPaidOut: "$ 50,87",
      cashIcon: true,
      coinIcon: true,
    },
    {
      date: "Oct 05, 2024 12:34 PM",
      promotionName: "Welcome Bonus",
      bonusType: "Store Discount",
      PurchasePrice: "$ 4,500.00",
      BonusReceived: "50,00 + 500,00",
      status: "Lost",
      bonusPaidOut: "$ 25,77",
      cashIcon: true,
      coinIcon: true,
    },
    {
      date: "Oct 15, 2024 12:34 PM",
      promotionName: "Fall Cashback",
      bonusType: "Store Discount",
      PurchasePrice: "$ 200.00",
      BonusReceived: "50,00 + 500,00",
      status: "-",
      bonusPaidOut: "$ 50,87",
      cashIcon: true,
      coinIcon: true,
    },
    {
      date: "Oct 05, 2024 12:34 PM",
      promotionName: "Summer Sizzle",
      bonusType: "Free Bet Cash",
      PurchasePrice: "-",
      BonusReceived: "$ 2000.00",
      status: "-",
      bonusPaidOut: "$ 40,70",
      cashIcon: false,
      coinIcon: false,
      freeCashIcon: true,
    },
    {
      date: "Oct 05, 2024 12:34 PM",
      promotionName: "Welcome Bonus",
      bonusType: "Store Discount",
      PurchasePrice: "$ 4,500.00",
      BonusReceived: "50,00 + 500,00",
      status: "Lost",
      bonusPaidOut: "$ 25,77",
      cashIcon: true,
      coinIcon: true,
    },
    {
      date: "Oct 05, 2024 12:34 PM",
      promotionName: "Summer Sizzle",
      bonusType: "Free Bet Cash",
      PurchasePrice: "-",
      BonusReceived: "$ 2000.00",
      status: "-",
      bonusPaidOut: "$ 40,70",
      cashIcon: false,
      coinIcon: false,
      freeCashIcon: true,
    },
    {
      date: "Oct 15, 2024 12:34 PM",
      promotionName: "Fall Cashback",
      bonusType: "Store Discount",
      PurchasePrice: "$ 200.00",
      BonusReceived: "50,00 + 500,00",
      status: "Lost",
      bonusPaidOut: "$ 50,87",
      cashIcon: true,
      coinIcon: true,
    },
    {
      date: "Oct 05, 2024 12:34 PM",
      promotionName: "Welcome Bonus",
      bonusType: "Store Discount",
      PurchasePrice: "$ 4,500.00",
      BonusReceived: "50,00 + 500,00",
      status: "Lost",
      bonusPaidOut: "$ 25,77",
      cashIcon: true,
      coinIcon: true,
    },
    {
      date: "Oct 15, 2024 12:34 PM",
      promotionName: "Fall Cashback",
      bonusType: "Store Discount",
      PurchasePrice: "$ 200.00",
      BonusReceived: "50,00 + 500,00",
      status: "-",
      bonusPaidOut: "$ 50,87",
      cashIcon: true,
      coinIcon: true,
    },
    {
      date: "Oct 05, 2024 12:34 PM",
      promotionName: "Summer Sizzle",
      bonusType: "Free Bet Cash",
      PurchasePrice: "-",
      BonusReceived: "$ 2000.00",
      status: "-",
      bonusPaidOut: "$ 40,70",
      cashIcon: false,
      coinIcon: false,
      freeCashIcon: true,
    },
    {
      date: "Oct 05, 2024 12:34 PM",
      promotionName: "Welcome Bonus",
      bonusType: "Store Discount",
      PurchasePrice: "$ 4,500.00",
      BonusReceived: "50,00 + 500,00",
      status: "Lost",
      bonusPaidOut: "$ 25,77",
      cashIcon: true,
      coinIcon: true,
    },
    {
      date: "Oct 05, 2024 12:34 PM",
      promotionName: "Summer Sizzle",
      bonusType: "Free Bet Cash",
      PurchasePrice: "-",
      BonusReceived: "$ 2000.00",
      status: "-",
      bonusPaidOut: "$ 40,70",
      cashIcon: false,
      coinIcon: false,
      freeCashIcon: true,
    },
    {
      date: "Oct 15, 2024 12:34 PM",
      promotionName: "Fall Cashback",
      bonusType: "Store Discount",
      PurchasePrice: "$ 200.00",
      BonusReceived: "50,00 + 500,00",
      status: "Lost",
      bonusPaidOut: "$ 50,87",
      cashIcon: true,
      coinIcon: true,
    },
  ];

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      sorter: (a, b) => new Date(a.date) - new Date(b.date),
    },
    {
      title: "Promotion Name",
      dataIndex: "promotionName",
      key: "promotionName",
      sorter: (a, b) => a.promotionName.localeCompare(b.promotionName),
    },
    {
      title: "Bonus Type",
      dataIndex: "bonusType",
      key: "bonusType",
      sorter: (a, b) => a.bonusType.localeCompare(b.bonusType),
    },
    {
      title: "Purchase Price",
      dataIndex: "PurchasePrice",
      key: "PurchasePrice",
      sorter: (a, b) => a.PurchasePrice.localeCompare(b.PurchasePrice),
    },
    {
      title: "Bonus Received",
      dataIndex: "BonusReceived",
      key: "BonusReceived",
      render: (text, record) => (
        <div>
          {record.cashIcon && record.coinIcon && (
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <img
                src={CashIcon}
                alt="Cash Icon"
                className="promo-table-icon"
              />{" "}
              50.00 +
              <img
                src={CoinIcon}
                alt="Coin Icon"
                className="promo-table-icon"
              />{" "}
              500.00
            </div>
          )}
          {record.freeCashIcon && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <img
                src={FreeCashIcon}
                alt="FreeCash Icon"
                className="promo-table-icon"
              />{" "}
              50.00
            </div>
          )}
        </div>
      ),
      sorter: (a, b) => a.BonusReceived.localeCompare(b.BonusReceived),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => (
        <span className={`promo-status ${text.toLowerCase()}`}>{text}</span>
      ),
      sorter: (a, b) => a.status.localeCompare(b.status),
    },
    {
      title: "Bonus Paid Out",
      dataIndex: "bonusPaidOut",
      key: "bonusPaidOut",
      sorter: (a, b) => a.bonusPaidOut.localeCompare(b.bonusPaidOut),
    },
  ];
  return (
    <div style={{ width: "100%" }}>
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        rowKey={(record) => record.id}
        scroll={{ x: 1400, y: 500 }}
        onRow={(record) => ({
          onClick: () => {
            console.log(record);
          },
        })}
      />
      <div className="pagination">
        <Pagination
          current={currentPage}
          total={data.length}
          pageSize={pageSize}
          showSizeChanger
          onChange={handlePaginationChange}
        />
      </div>
    </div>
  );
}

export default PromoTable;
